import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import LoginView from '../views/LoginView.vue'
import navigation from '../config/navigation.json'
import catalogs from '../config/catalogs.json'

Vue.use(VueRouter)
const views = { 'cortes-caja': () => import('../views/CortesCajaView.vue'), caja: () => import('../views/CajaView.vue'), fidelidad: () => import('../views/FidelidadView.vue'), cobros: () => import('../views/CobrosView.vue'), precios: () => import('../views/PreciosView.vue'), inventario: () => import('../views/PreciosView.vue'), agenda: () => import('../views/AgendaView.vue'), usuarios: () => import('../views/UsersView.vue'), roles: () => import('../views/RolesView.vue') }
const children = [{ path: 'dashboard', name: 'dashboard', component: () => import('../views/DashboardView.vue'), meta: { requiresAuth: true, title: 'Resumen' } }]
navigation.secciones.forEach(section => section.vistas.forEach(view => {
  if (view.clave === 'dashboard') return
  if (!views[view.clave] && !catalogs[view.clave]) return
  children.push({ path: view.ruta.slice(1), name: view.clave, component: views[view.clave] || (() => import('../views/CatalogView.vue')), meta: { requiresAuth: true, title: view.nombre, permission: `${view.clave}.leer`, catalog: view.clave, adminOnly: view.clave === 'cortes-caja' } })
}))
const router = new VueRouter({
  mode: 'history', base: process.env.BASE_URL,
  routes: [
    { path: '/login', name: 'login', component: LoginView },
    { path: '/', component: () => import('../components/AppShell.vue'), redirect: '/dashboard', meta: { requiresAuth: true }, children },
    { path: '*', redirect: '/dashboard' }
  ], scrollBehavior: () => ({ x: 0, y: 0 })
})
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    try {
      if (await store.dispatch('validate')) {
        if (to.meta.adminOnly && !(store.state.user || {}).esAdministrador) return next('/dashboard')
        if (to.meta.permission && !store.getters.can(to.meta.permission)) return next('/dashboard')
        return next()
      }
    } catch (_) { return next({ name: 'login', query: { connection: '1' } }) }
    return next({ name: 'login' })
  }
  if (to.name === 'login' && store.getters.authenticated && store.state.validated) return next({ name: 'dashboard' })
  next()
})
export default router
